<template>


  <div class="apply-return">
    <div class="bill-details" ref="container">
      <div class="nav acea-row">
        <div class="item" :class="types == 0 ? 'on' : ''" @click="changeTypes(0)">
          申请管理中心
        </div>
        <div class="item" :class="types == 1 ? 'on' : ''" @click="changeTypes(1)">
          申请记录
        </div>
      </div>
    </div>
    <div class="list">

      <div class="item acea-row row-between-wrapper">
        <div>管理中心</div>
        <div class="num acea-row row-left">
          <select v-model="reason">
            <option value="">选择管理中心</option>
            <option
              v-for="(text, index) in reasonList"
              :value="text.id"
              :key="index"
            >
              {{ text.name }}
            </option>
          </select>
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>

      <div class="item acea-row row-between-wrapper">
        <div class="name">申请服务地区</div>
        <div
                class="picker acea-row row-between-wrapper select-value form-control"
        >
          <div class="address">
            <div slot="right" @click.stop="show2 = true">
              {{ model2 || "请选择服务地区(荣誉院长不需要选择)" }}
            </div>
            <CitySelect
                    ref="cityselect"
                    v-model="show2"
                    :callback="result2"
                    :items="district"
                    :ready="ready"
                    provance=""
                    city=""
                    area=""
            ></CitySelect>
          </div>
          <div class="iconfont icon-dizhi font-color-red"></div>
        </div>
      </div>

      <div class="item acea-row row-between">
        <div class="title acea-row row-between-wrapper">
          <div>上传付款凭证</div>
          <div class="tip">( 最多可上传3张 )</div>
        </div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in refund_reason_wap_img"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="refund_reason_wap_img.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="refund_reason_wap_img.length < 3"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
    </div>
    <div class="returnBnt bg-color-red" @click="submit">提交申请</div>
  </div>
</template>

<script>
  import {CitySelect} from "vue-ydui/dist/lib.rem/cityselect";
import { getApplyGrade,postApply } from "@api/user";
  import { getCity } from "@api/public";
  import { openAddress } from "@libs/wechat";


import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
export default {
  name: "goodsReturn",
  components: {
    VueCoreImageUpload,
    CitySelect
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      orderInfo: {},
      reasonList: [],
      reason: "",
      refund_reason_wap_explain: "",
      refund_reason_wap_img: [],

      types:0,
      show2: false,
      model2: "",
      district: [],

      userAddress: { is_default: 0 },
      address: {},
      ready: false
    };
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    changeTypes: function(val) {
      if(val==0){
        this.$router.push({path:'/user/apply'})
      }else{
        this.$router.push({path:'/user/applyList'})
      }

    },
    getApplyGrade() {
      getApplyGrade().then(res => {
        this.reasonList = res.data.userLevel;
      });
    },
    submit() {
      const grade = this.reason,model2 = this.model2;
      if (!grade) return this.$dialog.toast({mes: "请选择申请的身份"});
      postApply({
        grade,
        model2,
        refund_reason_wap_img: this.refund_reason_wap_img.join(","),
      })
              .then(res => {
                this.$dialog.success(res.msg);
                this.$router.push({path:'/user/applyList'})
              })
              .catch(res => {
                this.$dialog.error(res.msg);
              });
    },
    getCityList: function () {
      let that = this;
      getCity()
              .then(res => {
                that.district = res.data;
                that.ready = true;
              })
              .catch(err => {
                that.$dialog.error(err.msg);
              });
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      this.address.district = ret.itemName3;
    },
    /*getUserAddress: function () {
      if (!this.id) return false;
      let that = this;
      getAddress(that.id)
              .then(res => {
                that.userAddress = res.data;
                that.model2 =
                        res.data.province + " " + res.data.city + " " + res.data.district;
                that.address.province = res.data.province;
                that.address.city = res.data.city;
                that.address.city_id = res.data.city_id;
              })
              .catch(err => {
                that.$dialog.error(err.msg);
              });
    },*/
  },
    mounted() {
      //this.getOrderDetail();
      this.getApplyGrade();

      //this.getUserAddress();
      this.getCityList();
    }
};
</script>
<style scoped>
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
